import { render, staticRenderFns } from "./terminal.vue?vue&type=template&id=60540f2c&scoped=true&"
import script from "./terminal.vue?vue&type=script&lang=js&"
export * from "./terminal.vue?vue&type=script&lang=js&"
import style0 from "./terminal.vue?vue&type=style&index=0&id=60540f2c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60540f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60540f2c')) {
      api.createRecord('60540f2c', component.options)
    } else {
      api.reload('60540f2c', component.options)
    }
    module.hot.accept("./terminal.vue?vue&type=template&id=60540f2c&scoped=true&", function () {
      api.rerender('60540f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/sharing_agreement/configuration_list/form/add/components/terminal.vue"
export default component.exports